import React from 'react'
import Link from 'gatsby-link'
import EventListItem from './EventListItem'

import styles from './EventList.module.css'

const   EventList = ({ eventsData }) => {
  console.log('EE', eventsData)
  const events = eventsData.map((event, i) => (
    <EventListItem
      key={i}
      title={event.node.frontmatter.title}
      displayDate={event.node.frontmatter.displayDate}
      location={event.node.frontmatter.location}
      description={event.node.frontmatter.description}
      slug={event.node.fields.slug}
      className={styles.eventListItem}
    />
  ))
  return <div className={styles.eventList}>{events}</div>
}

export default EventList



// WEBPACK FOOTER //
// ./src/components/events/EventList.js